import { render, staticRenderFns } from "./poster.vue?vue&type=template&id=cc9d3326&scoped=true"
import script from "./poster.vue?vue&type=script&lang=js"
export * from "./poster.vue?vue&type=script&lang=js"
import style0 from "./poster.vue?vue&type=style&index=0&id=cc9d3326&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9d3326",
  null
  
)

export default component.exports